<div
  appBsModal
  #userDelegationsModal="bs-modal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  (onShown)="onShown()"
  aria-hidden="true"
  [config]="{ keyboard: false }"
  >
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">
          <span>{{ l('UserDelegations') }}</span>
        </h4>
        <button class="btn btn-primary pull-right" (click)="manageUserDelegations()">
          <i class="fa fa-plus btn-md-icon"></i>
          <span class="d-none d-md-inline-block">
            {{ l('DelegateNewUser') }}
          </span>
        </button>
      </div>
      <div class="modal-body">
        <!--<Primeng-TurboTable-Start>-->
        <div class="primeng-datatable-container" [busyIf]="primengTableHelper.isLoading">
          <p-table
            #dataTable
            sortMode="multiple"
            (onLazyLoad)="getUserDelegations($event)"
            [value]="primengTableHelper.records"
            rows="{{ primengTableHelper.defaultRecordsCountPerPage }}"
            [paginator]="false"
            [lazy]="false"
            [tableStyle]="{'min-width': '25rem'}"
            >
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 30%" pSortableColumn="userName">
                  {{ l('UserName') }}
                  <p-sortIcon field="userName"></p-sortIcon>
                </th>
                <th style="width: 20%">
                  {{ l('StartTime') }}
                </th>
                <th style="width: 20%">
                  {{ l('EndTime') }}
                </th>
                <th style="width: 10%"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-record="$implicit">
              <tr>
                <td style="width: 30%">
                  <span class="p-column-title">{{ l('UserName') }}</span>
                  {{ record.username }}
                </td>
                <td style="width: 20%">
                  <span class="p-column-title">{{ l('StartTime') }}</span>
                  {{ record.startTime | luxonFormat: 'F	' }}
                </td>
                <td style="width: 20%">
                  <span class="p-column-title">{{ l('EndTime') }}</span>
                  {{ record.endTime | luxonFormat: 'F	' }}
                </td>
                <td style="width: 10%">
                  <button
                    class="btn btn-outline-danger btn-sm btn-icon"
                    (click)="deleteUserDelegation(record)"
                    >
                    <i class="fa fa-trash" [attr.aria-label]="l('Delete')"></i>
                  </button>
                </td>
              </tr>
            </ng-template>
          </p-table>
          @if (primengTableHelper.totalRecordsCount == 0) {
            <div class="primeng-no-data">
              {{ l('NoData') }}
            </div>
          }
          <div class="primeng-paging-container">
            <p-paginator
              [rows]="primengTableHelper.defaultRecordsCountPerPage"
              #paginator
              (onPageChange)="getUserDelegations($event)"
              [totalRecords]="primengTableHelper.totalRecordsCount"
              [rowsPerPageOptions]="primengTableHelper.predefinedRecordsCountPerPage"
              [showCurrentPageReport]="true"
                            [currentPageReportTemplate]="
                                l('TotalRecordsCount', primengTableHelper.totalRecordsCount)
                            "
            ></p-paginator>
          </div>
        </div>
        <!--<Primeng-TurboTable-End>-->
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light-primary fw-bold pull-right" (click)="close()">
          {{ l('Close') }}
        </button>
      </div>
    </div>
  </div>
</div>
<createNewUserDelegation #createNewUserDelegation (modalSave)="getUserDelegations()"></createNewUserDelegation>
